import classNames from 'classnames';

import styles from './core-entity-content.module.css';

type Props = {
    children: React.ReactNode;
    contentRef?: React.Ref<HTMLDivElement>;
    hasFullHeightSidebar?: boolean;
};

export function CoreEntityContent(props: Props) {
    return (
        <div
            ref={props.contentRef}
            className={classNames(styles['core-entity-content'], {
                [styles['core-entity-content--full-height-sidebar']]: props.hasFullHeightSidebar,
            })}
        >
            {props.children}
        </div>
    );
}
